import React from 'react';
export function TopBar() {
  return <div className="bg-deco-warm text-deco-text py-2 px-4 text-center text-xs sm:text-sm font-semibold tracking-wide" data-id="element-178">
      <p data-id="element-179">Producto 100% digital · Descarga inmediata</p>
    </div>;
}